import { render, staticRenderFns } from "./ShiftStatuses.vue?vue&type=template&id=01364c12&scoped=true&"
import script from "./ShiftStatuses.vue?vue&type=script&lang=js&"
export * from "./ShiftStatuses.vue?vue&type=script&lang=js&"
import style0 from "./ShiftStatuses.vue?vue&type=style&index=0&id=01364c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01364c12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCol,VDataTable,VIcon,VRow,VTooltip})
